import { http } from "../base"
/**
     * 记录日志
 
     */
export async function save_log(formData) {
    console.log("save_log", formData)
    try {
        const response = await http.post(`/tenant_operation_logs`, formData)
        console.log("save_log success:", response)
        return response
    } catch (error) {
        // 关键：打印完整的错误信息
        console.error("=== 完整错误信息 ===")
        console.error("error:", error)
        console.error("error.response:", error.response)
        console.error("error.response.status:", error.response?.status)
        console.error("error.response.data:", error.response?.data)  // 这里会显示后端返回的错误信息
        console.error("error.response.headers:", error.response?.headers)
        return error
    }
}